import { defineStore } from 'pinia';

export const useCartStore = defineStore('cart', {
  state: () => ({
    cart: null as any, // Details of the current cart
    carts: [] as any[], // List of all carts
    cartLines: [] as any[], // List of cart lines
    loading: false, // Indicates if a cart operation is in progress
  }),

  getters: {
    /**
     * Get cart by ID
     */
    getCartById: (state) => (cartId: string) => {
      return state.carts.find((cart) => cart.id === cartId) || null;
    },

    /**
     * Check if a cart is loading
     */
    isLoading: (state) => state.loading,
  },

  actions: {
    /**
     * Set loading state
     */
    setLoading(loading: boolean) {
      this.loading = loading;
    },

    /**
     * Clear the current cart
     */
    clearCart() {
      this.cart = null;
    },

    /**
     * Clear all carts
     */
    clearCarts() {
      this.carts = [];
    },

    /**
     * Add a cart to the store
     */
    addCart(cart: any) {
      this.carts.push(cart);
    },

    /**
     * Update a cart in the store
     */
    updateCart(cartId: string, updatedCart: any) {
      const index = this.carts.findIndex((cart) => cart.id === cartId);
      if (index !== -1) {
        this.carts[index] = updatedCart;
      }
      if (this.cart?.id === cartId) {
        this.cart = updatedCart;
      }
    },

    /**
     * Remove a cart from the store by ID
     */
    removeCart(cartId: string) {
      this.carts = this.carts.filter((cart) => cart.id !== cartId);
      if (this.cart?.id === cartId) {
        this.cart = null;
      }
    },

    /**
     * Add a product to the current cart
     */
    addProductToCart(product: any) {
      if (!this.cartLines) {
        this.cartLines = [];
      }
      const existingProduct = this.cartLines.find((line) => line.productId === product.id);
      if (existingProduct) {
        existingProduct.quantity += 1; // Increment quantity if product already exists
      } else {
        this.cartLines.push({
          productId: product.id,
          quantity: 1,
          ...product,
        });
      }
    },

    /**
     * Update a cart line
     */
    updateCartLine(lineId: string, updatedData: any) {
      const lineIndex = this.cartLines.findIndex((line) => line.id === lineId);
      if (lineIndex !== -1) {
        this.cartLines[lineIndex] = { ...this.cartLines[lineIndex], ...updatedData };
      }
    },

    /**
     * Remove a cart line
     */
    removeCartLine(lineId: string) {
      this.cartLines = this.cartLines.filter((line) => line.id !== lineId);
    },

    /**
     * Set cart lines
     */
    setCartLines(cartLines: any[]) {
      this.cartLines = cartLines;
    },

    /**
     * Clear cart lines
     */
    clearCartLines() {
      this.cartLines = [];
    },
  },
});
